import type { AccountContextType, WalletOptions } from '@bitte-ai/types';
import { atom, useAtomValue, useSetAtom } from 'jotai';
//@ts-ignore
export const accountStateAtom = atom<AccountContextType>({
  wallet: undefined,
  nearWalletId: undefined,
  account: undefined,
  accountId: null,
  evmWallet: undefined,
  evmAddress: undefined,
  chainId: undefined,
  suiWallet: undefined,
  suiAddress: undefined,
});

export function useAccount() {
  return useAtomValue(accountStateAtom);
}

export function useWalletState() {
  const setAccountState = useSetAtom(accountStateAtom);

  return async (wallet: WalletOptions = {}) => {
    const { near, evm, sui } = wallet;

    function updateWalletState() {
      setAccountState({
        wallet: near?.wallet,
        account: near?.account,
        nearWalletId: near?.nearWalletId || undefined,
        accountId: near?.accountId || null,
        evmWallet: evm,
        evmAddress: evm?.address,
        chainId: evm?.chainId,
        suiWallet: sui?.wallet,
        suiAddress: sui?.wallet?.address,
      });
    }

    updateWalletState();

    const noWalletConfigured =
      !near?.account && !near?.wallet && !evm && !sui?.wallet;
    if (noWalletConfigured) {
      console.warn(
        'No wallet or account configured - users will not be able to send transactions',
      );
    }
  };
}
